import { useMutation, useQueryClient } from "@tanstack/react-query";
import { useRouter } from "@tanstack/react-router";
import { httpClient } from "@/api/client";
import {
  getAvtalePrivatQueryKey,
  getAvtalerQueryKey,
  putAvtalePrivatMutation,
} from "@/api/generated/@tanstack/react-query.gen";
import { useToaster } from "@/features/toaster";
import { formatDateString } from "@/utils";

export const usePutPrivatAvtale = () => {
  const router = useRouter();
  const toast = useToaster();
  const queryClient = useQueryClient();

  const { mutate, isPending, isError } = useMutation({
    ...putAvtalePrivatMutation({
      client: httpClient,
    }),
    onSuccess: (res) => {
      queryClient.invalidateQueries({
        queryKey: [
          getAvtalerQueryKey({ client: httpClient }),
          getAvtalePrivatQueryKey({
            path: { id: res.avtale.avtaleId },
            client: httpClient,
          }),
        ],
      });
      const footer =
        res.avtale.lastUpdatedAt != null &&
        formatDateString(res.avtale.lastUpdatedAt);
      toast.success({
        messageKey: "pages.endre.form.suksess.suksess-tittel",
        footer,
      });
      router.navigate({
        to: `/`,
      });
    },
  });

  return { mutate, isPending, isError };
};
